import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './PrintSpecifications.module.css';
import { LanguageContext } from '../../../../../Context/Language.Context';
import { capitalizeFirstLetterEachWord } from '../../../../../Utils/helper-functions';
// import { PageText } from "../../../../../components/Text/Text";
// import { AnimatedComponent } from '../../../../../Hooks/use-framer-motion';
import { isEmptyList } from '../../../../../Utils/helper-functions';


const PrintSpecsContainer = ({ product, print = false }) => {

    const specListGroup1 = product.specList1;
    const specTitle1 = product.specTitle1;
    const specListGroup2 = product.specList2;
    const specTitle2 = product.specTitle2;


    const specListGroup3 = product.specList3;
    const specTitle3 = product.specTitle3;
    const specListGroup4 = product.specList4;
    const specTitle4 = product.specTitle4;

    const has1 = !isEmptyList(specListGroup1);
    const has2 = !isEmptyList(specListGroup2);
    const has3 = !isEmptyList(specListGroup3);
    const has4 = !isEmptyList(specListGroup4);

    return (
        <div className={styles.specificationComponentContainer}>
            {
                 // specTitle1 && specListGroup1 !== 0 &&
                has1 &&
                <div>
                    <span className={styles.printSpecListTitle}>{capitalizeFirstLetterEachWord(specTitle1)}</span>

                    <ul
                    // className={specListStyles.ulStyles}

                    >
                        {specListGroup1.map((e, idx) => (
                            <li
                                className={styles.specListItem}
                                // className={specListStyles.liStyles}
                                key={idx}

                            >
                                <span className={styles.specListItemText}> {e}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            }

            {
                // specTitle2 && specListGroup2 !== 0 &&
                 has2 &&
                <div>
                    <span className={styles.printSpecListTitle}>{capitalizeFirstLetterEachWord(specTitle2)}</span>

                    <ul
                    // className={specListStyles.ulStyles}

                    >
                        {specListGroup2.map((e, idx) => (
                            <li
                                className={styles.specListItem}
                                // className={specListStyles.liStyles}
                                key={idx}

                            >
                                <span className={styles.specListItemText}>{e}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            }

            {
                // specTitle3 && specListGroup3 !== 0 &&
                 has3 &&
                <div>
                    <span className={styles.printSpecListTitle}>{capitalizeFirstLetterEachWord(specTitle3)}</span>

                    <ul
                    // className={specListStyles.ulStyles}

                    >
                        {specListGroup3.map((e, idx) => (
                            <li
                                className={styles.specListItem}
                                // className={specListStyles.liStyles}
                                key={idx}

                            >
                                <span className={styles.specListItemText}>{e}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            }

            {
                // specTitle4 && specListGroup4 !== 0 &&
                 has4 &&
                <div>
                    <span className={styles.printSpecListTitle}>{capitalizeFirstLetterEachWord(specTitle4)}</span>

                    <ul
                    // className={specListStyles.ulStyles}

                    >
                        {specListGroup4.map((e, idx) => (
                            <li
                                className={styles.specListItem}
                                // className={specListStyles.liStyles}
                                key={idx}

                            >
                                <span className={styles.specListItemText}>{e}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </div>
    );
};

export default PrintSpecsContainer;